import { AxiosRequestConfig } from "axios";
import { GranularCatalogConfig } from "@granular/fabric-catalog-helpers";
import merge from "lodash/merge";

import { UserSvcInstance } from "./schemas";
import me from "./me";

const createUserSvcInstance = (
  userRequestConfig: GranularCatalogConfig,
  instanceRequestConfig?: AxiosRequestConfig,
): UserSvcInstance => {
  return {
    getUser: ({ domain, axiosRequestConfig }) =>
      me.GET({
        domain,
        userRequestConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
    updateUser: ({ domain, user, axiosRequestConfig }) =>
      me.PUT({
        domain,
        user,
        userRequestConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
      }),
  };
};

export default createUserSvcInstance;
